<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'RemissionGuide_Title' | translateWF: 'Remission Guides' }}</h1>
        @if (canCreate()) {
          <div class="page__title_buttons">
            <p-button (click)="redirectToDetail()" [label]="'Common_Add' | translateWF: 'Add'" icon="pi pi-plus" iconPos="left" />
          </div>
        }
      </div>
    </div>

    <div class="cs-page-list-grid">
      <!-- Filters Panel -->
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <!-- Data Table Panel -->
      <p-panel [header]="'Remission_Guides' | translateWF: 'Remission Guides'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="remissionGuides()" selectionMode="single" [rowHover]="true">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'RemissionGuide_Number' | translateWF: 'Number' }}</th>
                <th>{{ 'RemissionGuide_Remitter' | translateWF: 'Remitter' }}</th>
                <th>{{ 'RemissionGuide_Consignee' | translateWF: 'Consignee' }}</th>
                <th>{{ 'RemissionGuide_Issued_Date' | translateWF: 'Issued Date' }}</th>
                <th>{{ 'RemissionGuide_Transfer_Dates' | translateWF: 'Transfer Dates' }}</th>
                <th>{{ 'RemissionGuide_Lines' | translateWF: 'Lines' }}</th>
                <th>{{ 'RemissionGuide_Status' | translateWF: 'Status' }}</th>
                <th>{{ 'Common_Created_Date' | translateWF: 'Created' }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-guide>
              @let remGuide = guideStrict(guide);
              <tr class="cursor-pointer" (click)="redirectToDetail(remGuide.id)">
                <td>
                  <a class="font-semibold text-primary">{{ remGuide.number }}</a>
                </td>
                <td>{{ remGuide.remitter?.name || '-' }}</td>
                <td>{{ remGuide.consignee?.name || '-' }}</td>
                <td>{{ formatDate(remGuide.issuedDate) }}</td>
                <td>{{ formatDate(remGuide.transferStartDate) }} - {{ formatDate(remGuide.transferEndDate) }}</td>
                <td>
                  <p-tag severity="info" [value]="(remGuide.lines.length || 0).toString()" />
                </td>
                <td>
                  <p-tag [value]="getStatusLabel(remGuide.status)" [severity]="getStatusSeverity(remGuide.status)" />
                </td>
                <td>
                  @if (remGuide.createdDate) {
                    {{ remGuide.createdDate | date: 'short' }}
                  } @else {
                    <span class="text-gray-400">-</span>
                  }
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="8" class="text-center py-8">
                  {{ 'RemissionGuide_Not_Found' | translateWF: 'No remission guides found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize"
            [totalRecords]="totalRecords"
            [first]="(currentPage - 1) * pageSize"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[10, 25, 50, 100]"
          ></p-paginator>
        </p-card>
      </p-panel>
    </div>
  </div>
</main>

<p-toast position="bottom-right" key="br" />
